<template>
  <div class="mt-2 ml-2">
    <v-expansion-panels v-model="panel" multiple focusable>
      <v-expansion-panel v-for="(operador, key) in arrayOperadores" :key="key">
        <v-expansion-panel-header ripple>
          {{ operador.text }}
          <template v-slot:actions>
            <v-icon color="orangePcm">$expand</v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <TableInterna :valuesTable="operador.events" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div v-for="n in 3" :key="n">
      <v-divider vertical />
    </div>

    <v-row class="fixed-buttons">
      <v-col class="text-right" cols="12">
        <v-card height="50" rounded v-show="!hideButtons">
          <v-card-actions class="ml-3">
            <div>
              <v-icon
                @click="hideButtons = !hideButtons"
                class="grey--text mr-4 iconeEncolhe"
                >mdi-chevron-right</v-icon
              >
              <v-btn color="bluePcm" dark @click="expandeOperadores">{{
                expandir ? "Mostrar" : "Recolher"
              }}</v-btn>
            </div>
          </v-card-actions>
        </v-card>
        <v-card height="30" rounded v-show="hideButtons">
          <v-card-actions>
            <v-icon @click="hideButtons = !hideButtons" class="grey--text icone"
              >mdi-chevron-left</v-icon
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TableInterna from "./TableInterna";

export default {
  name: "ExpandListDisponibilidade",
  props: ["arrayOperadores", "panel"],
  components: { TableInterna },
  data: () => ({
    expandir: true,
    hideButtons: true,
    espandeOuEncolhePainelInterno: true,
  }),

  methods: {
    expandeOperadores() {
      if (this.expandir) {
        for (let i = 0; i <= this.operadores.length; i++) {
          this.panel.push(i);
        }
        this.expandir = !this.expandir;
      } else {
        this.panel = [];
        this.expandir = !this.expandir;
      }
    },
  },
};
</script>

<style scoped>
.fixed-buttons {
  position: fixed;
  right: 0;
  bottom: 0;
  margin-bottom: 30px;
  z-index: 4;
}

.icone {
  margin-top: -5px;
  width: 8px;
}

.iconeEncolhe {
  margin-top: -3px;
}
</style>
